import { createSlice } from "@reduxjs/toolkit";

export const clientesSlices = createSlice({
  name: "clientes",
  initialState: {
    value: [],
  },
  reducers: {
    addList: (state, action) => {
      //
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList } = clientesSlices.actions;

export default clientesSlices.reducer;
